<template>
  <div>
    <div
      class="modal fade"
      id="modal-actualizar-clave"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-sts pt-2 pb-2">
            <h4 class="modal-title text-white mb-0">
              <i class="fas fa-lock mr-2"></i>
              Cambiar clave
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
              @click="resetForm"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="alert alert-info py-2">
              <i class="fas fa-shield-alt mr-1"></i>
              Ingrese su clave actual y defina una nueva clave segura.
            </div>

            <div class="form-group">
              <label for="clave_actual">Clave actual</label>
              <div class="input-group">
                <input
                  :type="show.actual ? 'text' : 'password'"
                  id="clave_actual"
                  class="form-control"
                  v-model="form.clave_actual"
                  :class="$v.form.clave_actual.$error ? 'is-invalid' : ($v.form.clave_actual.$dirty && !$v.form.clave_actual.$invalid ? 'is-valid' : '')"
                  placeholder="Clave actual"
                  @blur="$v.form.clave_actual.$touch()"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="show.actual = !show.actual"
                    tabindex="-1"
                  >
                    <i class="fas" :class="show.actual ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
              <p class="bg-danger text-white px-2 py-1 mt-1 mb-0 rounded" v-if="$v.form.clave_actual.$error && !$v.form.clave_actual.required">
                La clave actual es requerida.
              </p>
            </div>

            <div class="form-group">
              <label for="clave_nueva">Clave nueva</label>
              <div class="input-group">
                <input
                  :type="show.nueva ? 'text' : 'password'"
                  id="clave_nueva"
                  class="form-control"
                  v-model="form.clave_nueva"
                  :class="$v.form.clave_nueva.$error ? 'is-invalid' : ($v.form.clave_nueva.$dirty && !$v.form.clave_nueva.$invalid ? 'is-valid' : '')"
                  placeholder="Clave nueva"
                  @blur="$v.form.clave_nueva.$touch()"
                  @input="$v.form.clave_nueva.$touch()"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="show.nueva = !show.nueva"
                    tabindex="-1"
                  >
                    <i class="fas" :class="show.nueva ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
              <p class="bg-danger text-white px-2 py-1 mt-1 mb-0 rounded" v-if="$v.form.clave_nueva.$error && !$v.form.clave_nueva.required">
                La clave nueva es requerida.
              </p>
              <div
                class="bg-danger text-white px-2 py-2 mt-1 rounded"
                v-if="$v.form.clave_nueva.$dirty && !$v.form.clave_nueva.strongPassword"
              >
                La contraseña no cumple con los parámetros de seguridad
                <ul class="mb-0 pl-3 mt-1">
                  <li :class="reglaClase(reglas.minLength)">
                    <i class="fas mr-1" :class="reglaIcono(reglas.minLength)"></i>
                    Debe tener al menos 12 caracteres
                  </li>
                  <li :class="reglaClase(reglas.mayuscula)">
                    <i class="fas mr-1" :class="reglaIcono(reglas.mayuscula)"></i>
                    Debe tener al menos una letra en mayúscula
                  </li>
                  <li :class="reglaClase(reglas.minuscula)">
                    <i class="fas mr-1" :class="reglaIcono(reglas.minuscula)"></i>
                    Debe tener al menos una letra en minúscula
                  </li>
                  <li :class="reglaClase(reglas.numero)">
                    <i class="fas mr-1" :class="reglaIcono(reglas.numero)"></i>
                    Debe tener al menos un número
                  </li>
                  <li :class="reglaClase(reglas.especial)">
                    <i class="fas mr-1" :class="reglaIcono(reglas.especial)"></i>
                    Debe tener al menos un carácter especial
                  </li>
                </ul>
              </div>
            </div>

            <div class="form-group mb-0">
              <label for="clave_confirmacion">Confirmación de clave nueva</label>
              <div class="input-group">
                <input
                  :type="show.confirmacion ? 'text' : 'password'"
                  id="clave_confirmacion"
                  class="form-control"
                  v-model="form.clave_confirmacion"
                  :class="$v.form.clave_confirmacion.$error ? 'is-invalid' : ($v.form.clave_confirmacion.$dirty && !$v.form.clave_confirmacion.$invalid ? 'is-valid' : '')"
                  placeholder="Confirme la clave nueva"
                  @blur="$v.form.clave_confirmacion.$touch()"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="show.confirmacion = !show.confirmacion"
                    tabindex="-1"
                  >
                    <i class="fas" :class="show.confirmacion ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
              </div>
              <p
                class="bg-danger text-white px-2 py-1 mt-1 mb-0 rounded"
                v-if="$v.form.clave_confirmacion.$error && !$v.form.clave_confirmacion.required"
              >
                La confirmación de clave es requerida.
              </p>
              <p
                class="bg-danger text-white px-2 py-1 mt-1 mb-0 rounded"
                v-if="$v.form.clave_confirmacion.$error && !$v.form.clave_confirmacion.sameAsPassword"
              >
                Las contraseñas deben ser iguales.
              </p>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-sm btn-secondary"
              data-dismiss="modal"
              @click="resetForm"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-sm btn-success"
              :disabled="$v.form.$invalid || guardando"
              @click="actualizarClave"
            >
              <i class="fas fa-spinner fa-spin mr-1" v-if="guardando"></i>
              <i class="fas fa-save mr-1" v-else></i>
              {{ guardando ? "Actualizando..." : "Actualizar clave" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, sameAs, minLength } from "vuelidate/lib/validators";

export default {
  name: "UpdatePassword",

  data() {
    return {
      form: {
        clave_actual: "",
        clave_nueva: "",
        clave_confirmacion: "",
      },
      show: {
        actual: false,
        nueva: false,
        confirmacion: false,
      },
      guardando: false,
    };
  },

  validations: {
    form: {
      clave_actual: {
        required,
      },
      clave_nueva: {
        required,
        minLength: minLength(12),
        strongPassword(value) {
          if (!value) return false;
          return (
            /[a-z]/.test(value) &&
            /[A-Z]/.test(value) &&
            /[0-9]/.test(value) &&
            /\W|_/.test(value) &&
            value.length >= 12
          );
        },
      },
      clave_confirmacion: {
        required,
        sameAsPassword: sameAs("clave_nueva"),
      },
    },
  },

  computed: {
    reglas() {
      const password = this.form.clave_nueva || "";
      return {
        minLength: password.length >= 12,
        mayuscula: /[A-Z]/.test(password),
        minuscula: /[a-z]/.test(password),
        numero: /[0-9]/.test(password),
        especial: /\W|_/.test(password),
      };
    },
  },

  methods: {
    reglaClase(ok) {
      return ok ? "text-success font-weight-bold" : "text-white";
    },

    reglaIcono(ok) {
      return ok ? "fa-check-circle" : "fa-times-circle";
    },

    resetForm() {
      this.form = {
        clave_actual: "",
        clave_nueva: "",
        clave_confirmacion: "",
      };
      this.show = {
        actual: false,
        nueva: false,
        confirmacion: false,
      };
      this.guardando = false;
      this.$nextTick(() => {
        if (this.$v) this.$v.$reset();
      });
    },

    actualizarClave() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      this.guardando = true;
      axios
        .post("/api/password/change", {
          current_password: this.form.clave_actual,
          password: this.form.clave_nueva,
          password_confirmation: this.form.clave_confirmacion,
        })
        .then((res) => {
          this.$swal({
            icon: "success",
            title: "Clave actualizada",
            text:
              (res.data && (res.data.message || res.data.success)) ||
              "Se actualizó la contraseña correctamente.",
          });
          this.$refs.closeModal.click();
          this.resetForm();
        })
        .catch((error) => {
          const msg =
            (error.response &&
              error.response.data &&
              (error.response.data.message ||
                (error.response.data.errors &&
                  Object.values(error.response.data.errors).flat().join(" ")))) ||
            "Sucedió un error, vuelva a intentarlo.";
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: msg,
          });
        })
        .finally(() => {
          this.guardando = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-danger ul li {
  list-style: none;
}
</style>
